export default {
  title: "Related Unsubmitted Work",
  content:
    "<span class='text-info text-weight-bold'>Corrective Work</span> exists for this " +
    "<span class='text-info text-weight-bold'>Issue</span> as <span class='text-info text-weight-bold'>Unsubmitted Work</span>. <br><br>" +
    "How would you like to proceed?",
}
